module.exports = __webpack_public_path__ + "media/packs/images/partners/chance_logo-b259e4ed7a86c06716e3513f548af2bb.jpg";